export const getAltFromSrc = (src: string) => {
  if (!src) return 'img'

  let canPush = false
  const alt: string[] = []

  for (let i = src.length - 1; i >= 0; i--) {
    if (src[i] === '/') {
      break
    }

    if (!canPush && src[i + 1] === '.') {
      canPush = true
    }

    if (canPush) {
      alt.unshift(src[i])
    }
  }

  return alt.join('').split('.')[0] || ''
}
